import { LegalLayout, LegalSection } from "@/components/landing/LegalLayout";

export default function CGU() {
  return (
    <LegalLayout
      testId="page-cgu"
      eyebrow="Conditions"
      title="Conditions Générales d'Utilisation"
      updated="juin 2026"
    >
      <LegalSection title="1. Objet">
        <p>
          Les présentes Conditions Générales d'Utilisation (CGU) ont pour objet de définir les
          modalités d'accès et d'utilisation du présent site vitrine édité par l'entreprise
          individuelle Leadzi CHR (SIRET 791 545 387 00049). En accédant au site, l'utilisateur
          accepte sans réserve les présentes CGU.
        </p>
      </LegalSection>

      <LegalSection title="2. Accès au site">
        <p>
          Le site est accessible gratuitement à tout utilisateur disposant d'un accès à Internet.
          L'éditeur s'efforce de maintenir le site accessible en permanence mais ne peut garantir
          une disponibilité continue&nbsp;; il peut suspendre ou interrompre l'accès, notamment pour
          des raisons de maintenance, sans que sa responsabilité puisse être engagée.
        </p>
      </LegalSection>

      <LegalSection title="3. Service présenté">
        <p>
          Le site a pour unique vocation de présenter l'application mobile Leadzi CHR et d'en
          permettre le téléchargement. Leadzi CHR permet aux commerciaux de déposer une opportunité
          commerciale correspondant à un besoin client qu'ils ne peuvent pas traiter. Les équipes
          Leadzi analysent l'opportunité et, le cas échéant, formulent une proposition de
          rémunération.
        </p>
        <p>
          L'analyse d'une opportunité et toute proposition éventuelle relèvent de l'appréciation de
          Leadzi. Aucune garantie de rémunération n'est attachée au simple dépôt d'une opportunité.
          Les conditions précises du service sont régies par les conditions propres à l'application.
        </p>
      </LegalSection>

      <LegalSection title="4. Obligations de l'utilisateur">
        <p>
          L'utilisateur s'engage à utiliser le site conformément à sa destination et à la
          réglementation en vigueur. Il s'interdit notamment toute utilisation frauduleuse,
          toute tentative d'atteinte à la sécurité ou au bon fonctionnement du site, ainsi que
          toute reproduction non autorisée de son contenu.
        </p>
      </LegalSection>

      <LegalSection title="5. Propriété intellectuelle">
        <p>
          La marque « Leadzi CHR », le logo et l'ensemble des contenus du site sont la propriété de
          l'éditeur et sont protégés. Toute exploitation non autorisée est interdite.
        </p>
      </LegalSection>

      <LegalSection title="6. Responsabilité">
        <p>
          Les informations figurant sur le site sont fournies à titre indicatif et n'ont pas de
          valeur contractuelle. L'éditeur ne saurait être tenu responsable des dommages directs ou
          indirects résultant de l'accès ou de l'utilisation du site.
        </p>
      </LegalSection>

      <LegalSection title="7. Liens externes">
        <p>
          Le site peut contenir des liens vers des sites tiers (notamment l'App Store et Google
          Play). L'éditeur n'exerce aucun contrôle sur ces sites et décline toute responsabilité
          quant à leur contenu.
        </p>
      </LegalSection>

      <LegalSection title="8. Modification des CGU">
        <p>
          L'éditeur se réserve le droit de modifier à tout moment les présentes CGU. La version
          applicable est celle en vigueur à la date de consultation du site.
        </p>
      </LegalSection>

      <LegalSection title="9. Droit applicable">
        <p>
          Les présentes CGU sont soumises au droit français. En cas de litige, et à défaut de
          résolution amiable, compétence est attribuée aux tribunaux français compétents.
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
